import { render, staticRenderFns } from "./KpAlert.vue?vue&type=template&id=0ec218f2&scoped=true"
import script from "./KpAlert.vue?vue&type=script&lang=js"
export * from "./KpAlert.vue?vue&type=script&lang=js"
import style0 from "./KpAlert.vue?vue&type=style&index=0&id=0ec218f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec218f2",
  null
  
)

export default component.exports